import { api } from 'app/utils/api/helpers'

type GrantStatus = 'active' | 'revoked' | 'expired'

interface SupportAccessSetting {
  allowSupportAccess: boolean
}

interface SupportAccessGrant {
  id: string
  userEmail: string
  teamId: string
  status: GrantStatus
  /** ISO8601 timestamp when access was granted */
  grantedAt: string
  /** ISO8601 timestamp when access expires */
  expiresAt: string
  /** ISO8601 timestamp when access was revoked, or null if still active */
  revokedAt: string | null
  revokedBy: string | null
}

export function fetchSupportAccessSetting(
  teamGUID: string,
): Promise<SupportAccessSetting> {
  return api.get(`/admin/support-access/teams/${teamGUID}/settings`)
}

export function updateSupportAccessSetting(
  teamGUID: string,
  allowSupportAccess: boolean,
): Promise<SupportAccessSetting> {
  return api.put(`/admin/support-access/teams/${teamGUID}/settings`, {
    allowSupportAccess,
  })
}

export function fetchSupportAccessGrants(
  teamGUID: string,
): Promise<SupportAccessGrant[]> {
  return api.get(`/admin/support-access/grants/team/${teamGUID}/history`)
}

export type { SupportAccessSetting, SupportAccessGrant, GrantStatus }
